import { useEffect, useState } from "react";
import { API_BASE_URL } from "../config";
import {
    Box, TextField, Button, Typography
} from "@mui/material";
import { DataGrid, GridColDef, GridRenderCellParams } from "@mui/x-data-grid";

import Layout from "../components/Layout";
import axiosExt from '../axios';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

interface SurveyResult {
    orderNumber: string;
    surveyDate: string;
    assignedTo: string;
    customer: string;
    contact: string;
    rate: number;
    comment: string;
}

export default function SurveyResultsPage() {
    const { t } = useTranslation();

    const [results, setResults] = useState<SurveyResult[]>([]);
    const [filters, setFilters] = useState({
        fromDate: "",
        toDate: "",
        minRate: "",
        maxRate: "",
        customerId: "",
        assignedToUserId: ""
    });

    const loadData = async () => {
        const token = localStorage.getItem("token");
        const params = { ...filters };
        const res = await axiosExt.get(`${API_BASE_URL}/satisfactionsurvey/results`, {
            headers: { Authorization: `Bearer ${token}` },
            params
        });
        setResults(res.data);
    };

    const navigate = useNavigate();

    useEffect(() => {
        loadData();
    }, []);

    const columns: GridColDef[] = [
        { field: "orderNumber", headerName: t("Order #"), width: 120 },
        { field: "surveyDate", headerName: t("Survey Date"), width: 180 },
        { field: "assignedTo", headerName: t("Assigned To"), width: 150 },
        { field: "customer", headerName: t("Customer"), width: 200 },
        { field: "contact", headerName: t("Contact"), width: 200 },
        { field: "rate", headerName: t("Rate"), width: 100 },
        { field: "comment", headerName: t("Comment"), width: 300 },
        {
            field: "actions",
            headerName: t("Actions"),
            width: 100,
            renderCell: (params: GridRenderCellParams) => (
                <>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => navigate(`/orderdetailspage/${params.row.orderId}?view=list`)}
                        style={{ marginRight: "10px" }}
                    >
                        {t("Order")}
                    </Button>

                </>
            ),
        },
    ];

    return (
        <Layout>
            <Box display="flex" width="100%" height="100vh" marginLeft="0px" paddingLeft="0px" marginRight="10px" paddingRight="10px">
                <Box sx={{ p: 2 }}>
                    <Typography variant="h5" gutterBottom>
                        {t("Survey Results")}
                    </Typography>

                    {/* Filters */}
                    <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
                        <TextField
                            type="date"
                            label={t("From")}
                            InputLabelProps={{ shrink: true }}
                            value={filters.fromDate}
                            onChange={(e) => setFilters({ ...filters, fromDate: e.target.value })}
                        />
                        <TextField
                            type="date"
                            label={t("To")}
                            InputLabelProps={{ shrink: true }}
                            value={filters.toDate}
                            onChange={(e) => setFilters({ ...filters, toDate: e.target.value })}
                        />
                        <TextField
                            type="number"
                            label={t("Min Rate")}
                            value={filters.minRate}
                            onChange={(e) => setFilters({ ...filters, minRate: e.target.value })}
                        />
                        <TextField
                            type="number"
                            label={t("Max Rate")}
                            value={filters.maxRate}
                            onChange={(e) => setFilters({ ...filters, maxRate: e.target.value })}
                        />
                        <Button variant="contained" color="primary" onClick={loadData}>{t("Apply")}</Button>
                    </Box>

                    {/* DataGrid */}
                    <div style={{ height: 600, width: "100%" }}>
                        <DataGrid
                            rows={results.map((r, i) => ({ id: i, ...r }))}
                            columns={columns}
                            pageSizeOptions={[10, 25, 50, 100]}
                            initialState={{
                                pagination: { paginationModel: { pageSize: 50, page: 0 } }
                            }}
                        />
                    </div>
                </Box>
            </Box>
        </Layout>
    );
}
